import { useContext, useEffect, useState } from "react";
import { UserEntity } from "./services/UserService";
import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { UserServiceContext } from ".";

interface UserProviderData {
    user?: UserEntity;
    loading: boolean;
    login: (token: string) => void;
    logout: () => void;
}

const UserProviderContext = React.createContext<UserProviderData>(
    {} as UserProviderData
);

interface UserProviderProps {}

export const UserProvider: FC<UserProviderProps> = ({
    children,
}: React.PropsWithChildren<UserProviderProps>) => {
    const userService = useContext(UserServiceContext);
    const [user, setUser] = useState<UserEntity | undefined>();
    const [loading, setLoading] = useState<boolean>(false);
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        userService
            .getLoggedInUser()
            .then((user) => setUser(user))
            .finally(() => setLoading(false));
    }, [userService]);

    const login = (token: string) => {
        userService.login(token).then((user) => {
            setUser(user);
        });
    };

    const logout = () => {
        userService.logout().then(() => {
            setUser(undefined);
            navigate("/");
        });
    };

    return (
        <UserProviderContext.Provider value={{ user, loading, login, logout }}>
            {loading ? (
                <h1 style={{ textAlign: "center" }}>Waking pets...</h1>
            ) : (
                children
            )}
        </UserProviderContext.Provider>
    );
};

export const useAuth = () => {
    return useContext(UserProviderContext);
};
